import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useSnackbar } from 'react-simple-snackbar';

// Components
import DefaultField from './DefaultField';
import DefaultPhone from '../../../components/common/DefaultPhone';
import DefaultSelect from '../../../components/common/DefaultSelect';
import { Text } from '../../../components/common/Texts';

// Hooks
import { useQueryParams } from '../../../hooks/useQueryParams';

// Redux
import { createRefered } from '../../../redux/api/refered';
import { useSelector } from 'react-redux';

// Utils
import { referedSchema } from '../../../utils/schemas';
import { optionsStyle } from '../../../utils/snackStyles';
import useReferralsPrograms from '../hook/useReferralsPrograms';

const FormRefered = (props) => {
    const {
        countries,
        student,
        handleDragma = false,
        misReferidos = false,
    } = props;

    const [openSnackbar] = useSnackbar(optionsStyle);
    const [loading, setLoading] = useState(false);
    const params = useQueryParams();
    const { dataReferralsPrograms } = useReferralsPrograms();

    console.log('dataReferralsPrograms :>> ', dataReferralsPrograms);

    const { user } = useSelector((state) => state.auth);

    const utm_campaign = params.get('utm_campaign') ?? 'mkt';
    const utm_content = params.get('utm_content') ?? 'mkt';
    const medium = params.get('utm_medium') ?? 'Referidos Bono 2024';
    const source = params.get('utm_source') ?? 'Referido';

    // FORMIK
    const initialValues = {
        name: '',
        lastName: '',
        country: 10,
        state: '',
        programs: '1',
        email: '',
        phone: '',
    };

    const handleSubmit = async (values, resetForm) => {
        const country = countries?.find((item) => item.id === values?.country);
        const program = dataReferralsPrograms?.find(
            (item) => item.id === values?.programs
        );

        const body = {
            partner_id: student?.partner_id,
            name: values?.name,
            last_name: values?.lastName,
            email: values?.email,
            phone: values?.phone,
            country_code: country?.code,
            city: values?.state?.toLowerCase(),
            id_prod_mkt: program?.id,
            program_name: program?.name,
            utm_medium: medium, // suborigen
            utm_campaign: utm_campaign,
            utm_content: utm_content,
            utm_source: source, // origen
        };
        setLoading(true);
        const request = await createRefered(body);
        setLoading(false);
        if (request.error) {
            openSnackbar('¡Ocurrió un error!');
        } else {
            handleDragma && handleDragma();
            openSnackbar('¡Referido exitoso!');
            resetForm({ values: '' });
        }
        // /api/v1/acropolis/referidos
    };

    const comportamientoInfo = (values) => {
        const program = dataReferralsPrograms.find(
            (item) => item.id === values?.programs
        );
        return {
            partner_id: user?.partner_id,
            partner_name: user?.name,
            name: values?.name,
            last_name: values?.lastName,
            email: values?.email,
            phone: values?.phone,
            program_name: program?.name,
        };
    };

    return (
        <FormWrapper misReferidos={misReferidos}>
            <div>
                <Text
                    color="#b31d15"
                    fontSize="32px"
                    fontWeight="700"
                    textAlign="center"
                >
                    Ingresa aquí <br /> los datos de tu referido
                </Text>
                <Formik
                    initialValues={initialValues}
                    // onSubmit={handleSubmit}
                    onSubmit={(values, { resetForm }) => {
                        handleSubmit(values, resetForm);
                    }}
                    validationSchema={referedSchema}
                >
                    {({ values, setFieldValue }) => {
                        return (
                            <FormContainer>
                                <Content>
                                    <DefaultField
                                        name="name"
                                        type="text"
                                        label="Nombre"
                                        required
                                        variant="outlined"
                                    />
                                    <DefaultField
                                        name="lastName"
                                        type="text"
                                        variant="outlined"
                                        label="Apellido"
                                        required
                                    />
                                    <DefaultField
                                        name="email"
                                        type="email"
                                        variant="outlined"
                                        label="Correo electrónico"
                                        required
                                    />
                                    <DefaultPhone
                                        styled={styledInput}
                                        name="phone"
                                        label="Teléfono *"
                                        value={values?.phone}
                                        setFieldValue={setFieldValue}
                                    />
                                    <DefaultSelectFake
                                        name="country"
                                        label="País de residencia"
                                        variant="outlined"
                                        options={countries || []}
                                        disabled={!countries ? true : false}
                                    />
                                    <DefaultField
                                        name="state"
                                        type="text"
                                        variant="outlined"
                                        label="Ciudad"
                                        required
                                    />
                                    {!dataReferralsPrograms ? null : (
                                        <DefaultSelectFake
                                            name="programs"
                                            label="Programas"
                                            variant="outlined"
                                            options={
                                                dataReferralsPrograms || []
                                            }
                                        />
                                    )}
                                </Content>

                                <ButtonWrapper>
                                    {!loading ? (
                                        student?.partner_id ? (
                                            <SubmitButton
                                                type="submit"
                                                value="Enviar"
                                                // Event action name
                                                data-behaviour-action={
                                                    'home_referir_añadir_referido'
                                                }
                                                // Event detail
                                                data-behaviour-detail={JSON.stringify(
                                                    comportamientoInfo(values)
                                                )}
                                                disabled={
                                                    student === false
                                                        ? true
                                                        : false
                                                }
                                            />
                                        ) : (
                                            <SubmitButton
                                                type="submit"
                                                value="Identificate"
                                                disabled={true}
                                            />
                                        )
                                    ) : (
                                        <SubmitButton
                                            type="submit"
                                            value="Cargando..."
                                            disabled
                                        />
                                    )}
                                </ButtonWrapper>
                            </FormContainer>
                        );
                    }}
                </Formik>
            </div>
        </FormWrapper>
    );
};

export default FormRefered;

const FormWrapper = styled.div`
    width: fit-content;
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    box-shadow:
        0px 12px 24px -15px #0000001a,
        0px 0px 10px -6px #00000040;
    background-color: #fff;
    ${(props) => {
        return props.misReferidos
            ? ``
            : `position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);`;
    }}
    border-radius: 20px;

    li {
        margin-left: 1rem;
        margin-bottom: 12px;
    }

    @media (max-width: 768px) {
        width: calc(100% - 6rem);
        padding: 2rem 2rem;
        overflow-x: hidden;
    }
`;

const FormContainer = styled(Form)`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 25px;
`;

const ButtonWrapper = styled.div`
    margin: 1rem 0;
    display: flex;
    justify-content: end;
    gap: 1rem;
`;

const SubmitButton = styled.input`
    cursor: pointer;
    height: 40px;
    border-radius: 10px;
    padding: 0px 1rem;
    background-color: #cd2118;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    border: 0px;

    :disabled {
        background-color: #a2a2a2;
        color: #f1f1f1;
        opacity: 0.5;
        cursor: not-allowed;

        :hover {
            background-color: #a2a2a2;
        }
    }

    :hover {
        background-color: #b31d15;
    }
`;

const Content = styled.div`
    width: 500px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    /* width: "100%"; */
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
`;

const styledInput = {
    width: '100%',
    padding: '10px 60px',
    borderRadius: '10px',
};

const DefaultSelectFake = styled(DefaultSelect)`
    height: 40px;
    border-radius: 10px;
`;
